import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Button, Skeleton, message, Modal } from "antd";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import FormInputNumber from "components/FormInputNumber/FormInputNumber";
import ScrollableContainer from "components/ScrollableContainer/ScrollableContainer";
import SectionCard from "components/SectionCard/SectionCard";
import Title from "components/Title/Title";

import { useFetchConstant } from "apis/constant";
import { useGetValues, patchValues, refetchValues } from "apis/valueStore";
import { withAppContext } from "contexts/AppContext/AppContext";
import { generateUniqueKey } from "utils/general";

import { SectionContainer } from "./Settings.styles";
import EmergencyContact from "../../components/EmergencyContact/EmergencyContact";
import { getGlobal, postGlobal } from "apis/global";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { success, error, confirm } = Modal;

const AdminEmergencyContactTemplate = ({ isAdmin }) => {
  const history = useHistory();
  const [form] = useForm();
  const [globalSettings, setGlobalSettings] = useState([]);
  const [loading, setLoading] = useState(false);

  const { isLoading: isValuesLoading, data } = useGetValues();
  const {
    isLoading: isGlobalConfigLoading,
    selection: globalConfigs,
  } = useFetchConstant("globalConfigs");

  const isLoading = isValuesLoading || isGlobalConfigLoading;

  const onBackButtonClick = () => history.goBack();

  useEffect(() => {
    getGlobalData();
  }, []);

  const getGlobalData = async () => {
    setLoading(true);
    const res = await getGlobal();
    if (res.data) {
      var buffer = res.data;
      buffer = buffer.map((data) => {
        return {
          ...data,
          _id: generateUniqueKey(),
        };
      });
      setGlobalSettings(buffer);
    }
    setLoading(false);
  };

  const updateGlobalData = async (data) => {
    setLoading(true);
    const res = await postGlobal(data);
    message.success(Locale.get("emergencyContact.updateSuccess"));
    getGlobalData();
  };

  const handleOnSaveButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      const payload = data.map((data, idx) => ({
        ...data,
        value: values[idx].value / 100,
      }));

      confirm({
        title: "Are you sure you want to overwrite existing data?",
        content:
          "You will not be able to undo this action, but you may update it again.",
        icon: <ExclamationCircleOutlined />,
        onOk() {
          patchValues(payload)
            .then(() => {
              refetchValues();
              success({
                title: "Update was successful!",
                onOk() {},
              });
            })
            .catch((ex) => {
              error({
                title: ex.message,
              });
            });
        },
        onCancel() {},
      });
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          <div>
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: "32px" }}
            >
              <ClickableTextButton
                text={Locale.get("emergencyContact.back")}
                onClick={onBackButtonClick}
                showIcon={true}
                type="back"
              />
            </Row>
            <EmergencyContact
              title={Locale.get("emergencyContact.manageEmergencyContact")}
              loading={loading}
              data={globalSettings}
              handleUpdateGlobalDataOnChange={updateGlobalData}
            />
          </div>
        </>
      )}
    </>
  );
};

export default withAppContext(AdminEmergencyContactTemplate);
